var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _g3, _path8, _path9, _path10, _g4, _path11, _path12, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadmj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_556_1127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 103,
    width: 600,
    height: 395
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 103H600V497.823H0V103Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_556_1127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584.684 330.582C575.512 315.499 562.753 302.641 547.562 293.15C548 290.258 548.359 287.309 548.645 284.342C549.152 279.048 549.41 273.941 549.41 269.055C549.41 223.246 530.135 181.777 498.991 151.749C467.842 121.738 424.806 103.164 377.268 103.164C342.4 103.164 309.919 113.202 282.748 130.443C257.259 146.614 236.504 169.119 222.903 195.603C219.271 194.519 215.547 193.609 211.767 192.898C205.042 191.628 198.119 190.962 191.081 190.962C163.025 190.962 137.463 201.346 118.326 218.356C100.673 234.035 88.4864 255.34 84.8221 279.31C61.3477 285.542 40.814 298.777 25.8481 316.525C9.69764 335.645 0 359.975 0 386.357C0 416.892 12.9517 444.646 33.8311 464.766C54.7105 484.885 83.5177 497.37 115.206 497.37H485.209C516.897 497.37 545.7 484.885 566.579 464.766C587.458 444.646 600.415 416.892 600.415 386.344C600.415 366.109 594.681 347.042 584.684 330.582ZM552.89 451.575C535.523 468.31 511.55 478.712 485.209 478.712H115.206C88.8597 478.712 64.8875 468.31 47.5203 451.575C30.153 434.839 19.363 411.74 19.363 386.344C19.363 364.359 27.406 344.124 40.7955 328.255C54.4709 312.039 73.7002 300.34 95.5983 295.912C99.9078 295.046 102.941 291.546 103.272 287.54C105.102 265.64 115.565 246.084 131.37 232.054C147.055 218.139 168.008 209.62 191.049 209.62C196.889 209.62 202.577 210.158 208.029 211.184C213.657 212.241 219.105 213.831 224.313 215.869C229.194 217.779 234.762 215.549 236.832 210.908C248.719 184.264 268.506 161.688 293.317 145.948C317.363 130.692 346.197 121.809 377.254 121.809C419.451 121.809 457.651 138.282 485.301 164.926C512.947 191.57 530.047 228.381 530.047 269.037C530.047 273.901 529.835 278.44 529.429 282.663C528.996 287.163 528.351 291.675 527.48 296.161C526.715 300.149 528.738 304.027 532.209 305.923C547.036 314.024 559.435 325.825 568.036 339.984C576.291 353.579 581.033 369.435 581.033 386.344C581.052 411.74 570.271 434.826 552.89 451.575Z",
    fill: "#081F42"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343.445 355.646C345.579 355.606 347.342 357.316 347.368 359.451C347.382 359.491 347.382 359.531 347.382 359.557C347.382 361.705 345.646 363.427 343.51 363.427C341.363 363.427 339.64 361.705 339.64 359.557C339.614 357.435 341.31 355.686 343.445 355.646ZM343.312 352.398C339.428 352.49 336.338 355.673 336.352 359.557C336.285 363.494 339.401 366.743 343.326 366.822C347.249 366.901 350.511 363.772 350.577 359.848C350.577 359.755 350.577 359.662 350.577 359.557C350.604 355.633 347.448 352.425 343.51 352.398C343.445 352.398 343.379 352.398 343.312 352.398Z",
    fill: "#081F42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M361.783 333.812H375.173C376.658 333.812 378.103 334.369 379.217 335.363L386.878 342.23C387.131 342.456 387.144 342.839 386.918 343.091C386.799 343.224 386.627 343.304 386.442 343.29L362.367 341.885C362.035 341.859 361.796 341.594 361.796 341.276L361.783 333.812ZM349.176 333.812C349.229 333.812 349.269 333.812 349.309 333.812H358.761V341.037C358.761 341.369 358.482 341.634 358.164 341.634C358.15 341.634 358.137 341.634 358.124 341.634L343.899 340.811C343.554 340.785 343.303 340.506 343.33 340.176C343.33 340.069 343.356 339.976 343.409 339.897L345.835 335.8C346.524 334.607 347.784 333.865 349.163 333.812H349.176ZM346.962 329.781C344.125 329.781 341.486 331.28 340.028 333.732L334.527 342.999C332.723 346.247 331.689 349.867 331.49 353.565V358.615C331.663 360.14 332.962 361.28 334.487 361.227C333.572 356.269 336.847 351.496 341.818 350.582C346.776 349.667 351.549 352.955 352.463 357.913C352.676 359.013 352.662 360.14 352.463 361.24H392.474C391.546 356.269 394.833 351.51 399.792 350.595C404.763 349.681 409.522 352.955 410.437 357.926C410.649 359.013 410.649 360.14 410.437 361.24H413.605C415.276 361.24 416.628 359.888 416.628 358.218V355.408C416.628 348.726 411.205 343.304 404.524 343.304H397.869C397.405 343.304 396.941 343.118 396.583 342.801L382.066 329.781H346.962Z",
    fill: "#081F42"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_556_1127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 267,
    y: 323,
    width: 64,
    height: 116
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267.298 323.406H330.071V438.73H267.298V323.406Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_556_1127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.437 411.673H316.667V425.355H303.437V411.673ZM280.847 411.673H294.091V425.355H280.847V411.673ZM303.437 388.512H316.667V402.194H303.437V388.512ZM280.847 388.512H294.091V402.194H280.847V388.512ZM302.058 366.719H309.336V374.235H302.058V366.719ZM288.006 366.719H295.271V374.235H288.006V366.719ZM302.058 352.268H309.336V359.771H302.058V352.268ZM288.006 352.268H295.271V359.771H288.006V352.268ZM295.614 323.395V338.175H288.641L281.377 351.99V374.235H274.496L267.298 381.818V438.731H330.017V381.818L322.832 374.235H315.951V351.99L308.686 338.175H301.713V323.395H295.614Z",
    fill: "#081F42"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M401.288 355.699C403.424 355.633 405.213 357.316 405.279 359.451C405.279 359.491 405.279 359.531 405.279 359.557C405.306 361.705 403.595 363.454 401.461 363.494C399.327 363.52 397.576 361.811 397.538 359.676C397.538 359.637 397.538 359.597 397.538 359.557C397.538 357.462 399.194 355.752 401.288 355.699ZM401.288 352.398C397.418 352.49 394.315 355.673 394.342 359.557C394.249 363.494 397.352 366.756 401.275 366.849C405.213 366.94 408.474 363.839 408.567 359.901C408.567 359.795 408.567 359.676 408.567 359.557C408.593 355.633 405.425 352.425 401.501 352.398C401.434 352.398 401.368 352.398 401.288 352.398Z",
    fill: "#081F42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M357.393 391.694C357.393 391.92 357.566 392.092 357.778 392.092C357.884 392.092 357.976 392.052 358.056 391.986L369.696 381.34C370.212 380.876 370.982 380.876 371.485 381.34L396.66 404.354C397.204 404.845 397.244 405.693 396.753 406.224C396.501 406.503 396.144 406.661 395.772 406.661H345.409C344.68 406.661 344.096 406.065 344.083 405.336C344.083 404.965 344.242 404.606 344.521 404.354L350.659 398.747C350.738 398.667 350.777 398.561 350.777 398.455V387.65C350.777 386.922 351.374 386.325 352.103 386.325H356.067C356.783 386.325 357.38 386.922 357.38 387.65L357.393 391.694Z",
    fill: "#081F42"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_556_1127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 347,
    y: 408,
    width: 48,
    height: 31
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M347.624 408.836H394.049V438.733H347.624V408.836Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_556_1127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.611 409.035H347.794V438.334C347.794 438.546 347.98 438.732 348.205 438.732H357.485V424.228C357.498 419.602 361.263 415.863 365.877 415.89C370.49 415.903 374.215 419.628 374.229 424.228V438.732H381.215V429.597C381.228 427.941 382.58 426.601 384.238 426.615C385.881 426.628 387.207 427.954 387.22 429.597V438.732H393.624C393.836 438.732 394.021 438.546 394.021 438.334V409.433C394.021 409.221 393.836 409.035 393.624 409.035H393.611Z",
    fill: "#081F42"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M439.031 214.424L366.15 141.551L293.27 214.424C292.988 214.709 292.735 215.016 292.513 215.351C292.29 215.683 292.102 216.036 291.949 216.407C291.796 216.777 291.68 217.159 291.603 217.552C291.525 217.945 291.486 218.343 291.486 218.742C291.486 219.144 291.525 219.542 291.603 219.934C291.68 220.327 291.796 220.708 291.949 221.08C292.102 221.451 292.29 221.802 292.513 222.136C292.735 222.469 292.988 222.778 293.27 223.062L366.15 295.936L439.031 223.062C439.313 222.778 439.566 222.469 439.788 222.136C440.01 221.802 440.197 221.451 440.351 221.08C440.505 220.708 440.62 220.327 440.697 219.934C440.776 219.542 440.814 219.144 440.814 218.742C440.814 218.343 440.776 217.945 440.697 217.552C440.62 217.159 440.505 216.777 440.351 216.407C440.197 216.036 440.01 215.685 439.788 215.351C439.566 215.016 439.313 214.709 439.031 214.424ZM366.15 241.56L343.325 218.736L366.15 195.912L388.976 218.736L366.15 241.56Z",
    fill: "#2684FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_556_1127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 315,
    y: 141,
    width: 52,
    height: 78
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M315.477 141.531H366.404V218.992H315.477V141.531Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_556_1127)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_556_1127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 315,
    y: 141,
    width: 52,
    height: 78
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M366.148 196.052C365.705 195.609 365.274 195.155 364.852 194.691C364.431 194.228 364.022 193.753 363.624 193.27C363.226 192.785 362.841 192.292 362.467 191.789C362.094 191.285 361.733 190.774 361.384 190.252C361.036 189.732 360.7 189.204 360.377 188.666C360.055 188.129 359.745 187.584 359.449 187.033C359.154 186.481 358.871 185.921 358.602 185.356C358.334 184.789 358.079 184.217 357.838 183.639C357.597 183.061 357.372 182.477 357.159 181.887C356.947 181.297 356.75 180.703 356.567 180.105C356.384 179.505 356.215 178.901 356.063 178.295C355.909 177.688 355.77 177.076 355.646 176.462C355.523 175.849 355.414 175.232 355.32 174.612C355.227 173.992 355.148 173.371 355.085 172.748C355.023 172.124 354.974 171.499 354.943 170.874C354.909 170.249 354.892 169.623 354.891 168.996C354.889 168.37 354.902 167.743 354.931 167.117C354.959 166.492 355.003 165.867 355.063 165.243C355.121 164.62 355.197 163.998 355.285 163.378C355.376 162.758 355.481 162.141 355.601 161.526C355.72 160.91 355.855 160.298 356.006 159.69C356.155 159.083 356.32 158.478 356.499 157.878C356.678 157.278 356.872 156.683 357.081 156.091C357.29 155.501 357.512 154.916 357.749 154.335C357.987 153.755 358.238 153.182 358.502 152.614C358.767 152.047 359.047 151.485 359.339 150.932C359.632 150.378 359.938 149.832 360.257 149.292C360.576 148.754 360.909 148.222 361.253 147.7C361.599 147.177 361.957 146.662 362.328 146.157C362.698 145.653 363.08 145.156 363.475 144.67C363.87 144.183 364.277 143.707 364.695 143.24C365.113 142.774 365.541 142.317 365.983 141.871L315.883 191.65L343.065 218.83L366.148 196.052Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_556_1127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.883 141.871V218.83H366.148V141.871H315.883Z",
    fill: "url(#paint0_linear_556_1127)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_556_1127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 365,
    y: 218,
    width: 52,
    height: 79
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M365.981 218.559H416.481V296.019H365.981V218.559Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_556_1127)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_556_1127",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 366,
    y: 218,
    width: 51,
    height: 78
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M389.034 218.656L366.148 241.54C366.593 241.985 367.028 242.44 367.451 242.906C367.872 243.373 368.283 243.847 368.683 244.334C369.082 244.82 369.47 245.317 369.845 245.822C370.219 246.327 370.582 246.841 370.931 247.365C371.281 247.886 371.618 248.418 371.941 248.958C372.265 249.498 372.575 250.044 372.872 250.599C373.168 251.154 373.451 251.716 373.72 252.285C373.989 252.853 374.245 253.428 374.485 254.01C374.726 254.59 374.953 255.177 375.164 255.77C375.376 256.362 375.574 256.959 375.757 257.561C375.94 258.164 376.107 258.769 376.261 259.379C376.413 259.99 376.552 260.603 376.674 261.22C376.797 261.838 376.904 262.457 376.996 263.079C377.09 263.702 377.167 264.326 377.229 264.953C377.29 265.578 377.336 266.205 377.367 266.834C377.397 267.462 377.412 268.091 377.412 268.721C377.412 269.349 377.397 269.978 377.367 270.607C377.336 271.235 377.289 271.862 377.229 272.489C377.167 273.114 377.09 273.739 376.996 274.361C376.904 274.983 376.797 275.603 376.674 276.22C376.552 276.837 376.413 277.451 376.261 278.061C376.107 278.671 375.94 279.278 375.757 279.88C375.574 280.481 375.376 281.078 375.164 281.672C374.953 282.264 374.726 282.85 374.485 283.43C374.245 284.012 373.989 284.587 373.72 285.156C373.451 285.724 373.168 286.287 372.872 286.841C372.575 287.396 372.265 287.944 371.941 288.482C371.618 289.022 371.281 289.554 370.931 290.077C370.582 290.6 370.219 291.114 369.845 291.618C369.468 292.125 369.082 292.62 368.683 293.106C368.283 293.593 367.872 294.069 367.451 294.534C367.028 295 366.593 295.457 366.148 295.901L416.203 245.852L389.034 218.656Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_556_1127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M366.148 218.656V295.901H416.203V218.656H366.148Z",
    fill: "url(#paint1_linear_556_1127)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_556_1127",
    x1: 379.589,
    y1: 155.311,
    x2: 315.979,
    y2: 218.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0153CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#0154CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#0255CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395071,
    stopColor: "#0356D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#0356D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#0357D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#0458D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#0558D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#0659D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#065AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#075BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#085CD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#085DD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#095ED8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#0A5FD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#0B60DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#0B61DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0C62DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#0D63DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#0E64DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#0E65DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#0F66E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#1067E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#1068E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#1169E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#126AE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570312,
    stopColor: "#136BE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#136CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#146CE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#156DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#156EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604929,
    stopColor: "#166FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#1770EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#1770EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1871EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#1872ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#1973EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#1A74EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#1B75F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#1B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#1C77F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#1D78F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#1D79F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#1E7AF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#1F7BF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#207CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#207DF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#217EF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#227FF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#227FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2380FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#2481FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#2582FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#2583FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#2684FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2684FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2684FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_556_1127",
    x1: 352.557,
    y1: 282.311,
    x2: 416.204,
    y2: 218.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382812,
    stopColor: "#0153CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#0154CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393179,
    stopColor: "#0255CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#0255CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#0356D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#0457D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#0458D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#0559D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#065AD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445312,
    stopColor: "#065BD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#075CD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#085CD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#095DD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476562,
    stopColor: "#095ED9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#0A5FDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#0B60DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0C61DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507812,
    stopColor: "#0C62DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#0D63DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#0E64DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#0E65DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#0F66E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#1067E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#1168E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#1169E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#126AE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#136BE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#136CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#146DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601562,
    stopColor: "#156EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606821,
    stopColor: "#166FE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#166FEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617188,
    stopColor: "#1670EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#1770EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#1871EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#1972ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#1973EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#1A74EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664062,
    stopColor: "#1B75F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#1B76F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#1C77F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#1D78F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#1E79F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#1E7AF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#1F7BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#207CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726562,
    stopColor: "#217DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#217EF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#227FFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#2380FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#2381FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#2482FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#2583FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#2684FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#2684FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#2684FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadmj);
export default __webpack_public_path__ + "static/media/RADMJ.2c09036fa5660e83afb1a4f2e118ed1f.svg";
export { ForwardRef as ReactComponent };